import {Injectable} from '@angular/core';
import {AppPreferences} from "../../domain/models";

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {

  public appPreferences: AppPreferences = new AppPreferences();

  constructor() {
    console.log(JSON.parse(localStorage.getItem("app_prefs")))
    this.appPreferences = JSON.parse(localStorage.getItem("app_prefs"))
    if (this.appPreferences == null) this.setAppPreferences(new AppPreferences())
    this.reloadPreferences()
  }

  public setAppPreferences(prefs: AppPreferences) {
    localStorage.setItem("app_prefs", JSON.stringify(prefs))
    this.appPreferences = prefs;
  }

  public reloadPreferences() {
    this.appPreferences = JSON.parse(localStorage.getItem("app_prefs"))
  }

}
